"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = Switch;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: ", "px;\n    background-color: ", ";\n    display: inline-block;\n    box-shadow: 0 0 0 ", "px ", ";\n    border-radius: ", "px;\n    transition: all 0.25s;\n    top: 0;\n    transform: translateX(", ");\n    position: absolute;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: ", "px;\n    position: relative;\n    border-radius: ", "px;\n    transition: all 0.25s;\n    margin: ", "px;\n    background-color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["  \n    position: relative;\n    display: inline-block; \n    width: fit-content;\n    cursor: ", ";\n    margin: ", "px;\n    &:hover::before {\n      transition: all 0.25s;\n      content: \"\";\n      position: absolute;\n      background-color: ", ";\n      border-radius: ", "px;\n      width: ", "px;\n      height: ", "px;\n      transform: translateZ(-1px);\n      left: -", "px;\n      top: -", "px;\n    }\n    &:active::before {\n      transition: all 0.25s;\n      content: \"\";\n      position: absolute;\n      background-color: ", ";\n      border-radius: ", "px;\n      width: ", "px;\n      height: ", "px;\n      transform: translateZ(-1px);\n      left: -", "px;\n      top: -", "px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ToggleWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.spacingObj.margin / 2;
}, function (props) {
  return props.disabled ? 'none' : props.checked ? props.colorObj.checkedHoverColor : props.colorObj.hoverColor;
}, function (props) {
  return props.spacingObj.width;
}, function (props) {
  return props.spacingObj.width * 2;
}, function (props) {
  return props.spacingObj.height * 2;
}, function (props) {
  return props.checked ? 0 : props.spacingObj.width / 2 - 2;
}, function (props) {
  return props.spacingObj.height / 2 + 2;
}, function (props) {
  return props.disabled ? 'none' : props.checked ? props.colorObj.checkedActiveColor : props.colorObj.activeColor;
}, function (props) {
  return props.spacingObj.width;
}, function (props) {
  return props.spacingObj.width * 2;
}, function (props) {
  return props.spacingObj.height * 2;
}, function (props) {
  return props.checked ? 0 : props.spacingObj.width / 2 - 2;
}, function (props) {
  return props.spacingObj.height / 2 + 2;
});

var ToggleBackground = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.spacingObj.toggleBackgroundWidth;
}, function (props) {
  return props.spacingObj.toggleBackgroundHeight;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return (props.spacingObj.height - props.spacingObj.borderWidth * 2 - props.spacingObj.toggleBackgroundHeight) / 2;
}, function (props) {
  return !props.checked || props.disabled ? props.colorObj.toggleBackground : props.colorObj.fillColor;
});

var ToggleHandle = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.spacingObj.toggleHandleDiameter;
}, function (props) {
  return props.spacingObj.toggleHandleDiameter;
}, function (props) {
  return props.disabled ? props.colorObj.toggleDisabledcolor : props.colorObj.fillColorSecondary;
}, function (props) {
  return props.spacingObj.borderWidth;
}, function (props) {
  return props.disabled ? props.colorObj.toggleDisabledcolor : props.colorObj.toggleBordercolor;
}, function (props) {
  return props.spacingObj.width;
}, function (props) {
  return props.checked ? props.spacingObj.width - (props.spacingObj.toggleHandleDiameter / 2 - props.spacingObj.borderWidth) + 'px' : '0';
});
/**
 * Switches are used to toggle an option on or off.
 * @example import { Switch } from '@desktop/react';
 */


function Switch(props) {
  var inherit = "switches";
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var colors = context.getColors()[inherit];
  var spacing = context.getSpacing()[inherit];

  var _useState = (0, _react.useState)(props.checked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var isFirstRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      props.onChange(checked);
    }
  }, [checked]);
  (0, _react.useEffect)(function () {
    setChecked(props.checked);
  }, [props.checked]);

  function handlechange() {
    if (props.disabled) {
      return false;
    }

    setChecked(!checked);
  }

  return /*#__PURE__*/_react["default"].createElement(ToggleWrapper, {
    onClick: handlechange,
    colorObj: colors,
    spacingObj: spacing,
    checked: checked,
    disabled: props.disabled
  }, /*#__PURE__*/_react["default"].createElement(ToggleBackground, {
    colorObj: colors,
    spacingObj: spacing,
    checked: checked,
    disabled: props.disabled,
    style: props.style
  }), /*#__PURE__*/_react["default"].createElement(ToggleHandle, {
    colorObj: colors,
    spacingObj: spacing,
    checked: checked,
    disabled: props.disabled,
    style: props.handleStyle
  }));
} //TODO: Why value and checked


Switch.propTypes = {
  /**Sets the position of the swich to be on or off. */
  checked: _propTypes["default"].bool,

  /**The callback function fired when the value of the switch is changed. */
  onChange: _propTypes["default"].func,

  /**Option to enable and disable the switch controls. */
  disabled: _propTypes["default"].bool,

  /**The overriding style object applied to the swich background. */
  style: _propTypes["default"].object,

  /**The overriding style object applied to the switch handle. */
  handleStyle: _propTypes["default"].object
};
Switch.defaultProps = {
  checked: false,
  onChange: function onChange() {
    return false;
  },
  disabled: false,
  style: {},
  handleStyle: {}
};